<template>
  <el-dialog
    custom-class="dialog-reset-password"
    lock-scroll
    :modal-append-to-body="true"
    :append-to-body="true"
    title=""
    width="520px"
    :close-on-click-modal="false"
    :visible="value"
    @close="closeDialog"
    :show-close="false"
  >
    <div>
      <div class="title">{{ $lang("修改密码") }}</div>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        :label-width="lang === 'CN' ? '100px' : '190px'"
      >
        <el-form-item :label="$lang('旧密码')" prop="oldPassword">
          <el-input
            :placeholder="$lang('请输入旧密码')"
            maxlength="30"
            type="password"
            autocomplete="oldPassword-password"
            v-model="form.oldPassword"
          >
            <i slot="prefix" class="iconfont icondengluzhuce_mima"></i>
          </el-input>
        </el-form-item>
        <el-form-item :label="$lang('新密码')" prop="password">
          <el-input
            :placeholder="$lang('请输入新密码')"
            maxlength="32"
            name="password"
            autocomplete="new-password"
            :type="isShowPassword ? 'text' : 'password'"
            v-model="form.password"
          >
            <i slot="prefix" class="iconfont icondengluzhuce_mima"></i>
            <i
              slot="suffix"
              class="iconfont pointer"
              :class="[
                isShowPassword
                  ? 'icondenglu_ico_mimakeshi'
                  : 'icondenglu_ico_mimayincang'
              ]"
              @click="toggleIcon"
            ></i>
          </el-input>
        </el-form-item>
        <el-form-item :label="$lang('确认新密码')" prop="passwordAgain">
          <el-input
            :placeholder="$lang('请再次输入新密码')"
            maxlength="32"
            type="password"
            autocomplete="new-password"
            v-model="form.passwordAgain"
          >
            <i slot="prefix" class="iconfont icondengluzhuce_mima"></i>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $lang("取消") }}</el-button>
      <el-button type="primary" :loading="btnLoading" @click="sumitForm">{{
        $lang("提交")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import * as Api from "@/api";
import { RESPONSE_SUCCESS } from "@/constants";
import { RULES } from "@/constants/rules";
import mixin from "@/mixin/tencentCaptcha";
import { AESUtil } from "@/utils/";
import { mapGetters } from "vuex";
export default {
  name: "DialogResetPassword",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    loginForm: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mixins: [mixin],
  data() {
    return {
      form: {},
      isShowPassword: false,
      btnLoading: false
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    rules() {
      return {
        oldPassword: [RULES.password, RULES.inputPassword],
        password: [RULES.password, RULES.passwordNew],
        passwordAgain: [
          RULES.password,
          { validator: this.validatePass, trigger: "blur" }
        ]
      };
    }
  },
  methods: {
    closeDialog() {
      this.$emit("input", false);
      this.$refs.form.resetForm();
    },
    validatePass(rule, value, callback) {
      if (value === "") {
        callback(new Error(this.$lang("请再次输入密码")));
      } else if (value !== this.form.password) {
        callback(new Error(this.$lang("两次输入密码不一致!")));
      } else {
        callback();
      }
    },
    toggleIcon() {
      this.isShowPassword = !this.isShowPassword;
    },
    sumitForm() {
      this.$refs.form.validate(async (vaild) => {
        if (!vaild) return;
        const params = {
          account: this.loginForm.account,
          password: AESUtil.aesEncrypt(this.form.password),
          oldPassword: AESUtil.aesEncrypt(this.form.oldPassword)
        };
        this.btnLoading = true;
        const { code, msg } = await Api.updatePwd(params);
        this.btnLoading = false;
        if (code === RESPONSE_SUCCESS) {
          this.$message.success(this.$lang(msg));
          this.$emit("input", false);
        } else {
          this.$message.error(this.$lang(msg));
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .dialog-reset-password {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0 20px;
  }
  .title {
    padding-top: 20px;
    font-size: 20px;
    font-weight: bold;
    color: #2b2d42;
  }
  .el-form {
    margin-top: 20px;
  }
  .el-form-item {
    margin-bottom: 30px !important;
  }
  .el-form-item__content {
    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>
